window['serviceDiscoveryPrefix']='/pp-portal-api/v1/mfe'